var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-scrollable modal-xl",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "visitorManagement.cockpit.directRegistration.modal.title"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _vm.groupSurveyExtension
                  ? _c("GroupEditor", {
                      ref: "groupEditor",
                      attrs: {
                        allUsers: [],
                        availableSalutations: [],
                        group: _vm.groupSurveyExtension,
                        groupSelector: "group",
                        groupCopyFunction: e =>
                          _vm.GroupSurveyExtension.fromJS(e),
                        groupSaveFunction: _vm.saveGroup,
                        hiddenTabs: ["users"],
                        tabTitles: new Map([
                          [
                            "usersExternal",
                            _vm.$t(
                              "visitorManagement.advanceRegistration.tabs.usersExternal"
                            )
                          ]
                        ]),
                        hidePinned: true,
                        hideExternalUserDisabled: true,
                        allowNoEmailForExternalUsers: true
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "generalNameLabel",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "visitorManagement.advanceRegistration.reasonOfVisit"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "generalAfter",
                            fn: function({ group }) {
                              return [
                                _c("GeneralAfter", {
                                  attrs: {
                                    group: group,
                                    canToggleEnableScanEntry:
                                      _vm.canToggleEnableScanEntry
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "datePickerText",
                                        fn: function({ startDate, endDate }) {
                                          return [
                                            !startDate || !endDate
                                              ? [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "visitorManagement.advanceRegistration.selectDate"
                                                      )
                                                    )
                                                  )
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.formatDateTime(
                                                          startDate
                                                        )
                                                      ) +
                                                      " - " +
                                                      _vm._s(
                                                        _vm.formatDateTime(
                                                          endDate
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                          ]
                                        }
                                      },
                                      {
                                        key: "approvals",
                                        fn: function() {
                                          return [_c("div")]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            }
                          },
                          {
                            key: "editModalTabs",
                            fn: function({ group }) {
                              return [
                                !_vm.surveySelectionViaGroups
                                  ? _c(
                                      "TabSlot",
                                      {
                                        attrs: {
                                          id: "surveys",
                                          title: _vm.$t("survey.group.surveys"),
                                          order: 30
                                        }
                                      },
                                      [
                                        _c("GroupSurveyEditor", {
                                          attrs: { group: group }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.surveySelectionViaGroups
                                  ? _c(
                                      "TabSlot",
                                      {
                                        attrs: {
                                          id: "surveysFromGroup",
                                          title: _vm.$t(
                                            "survey.group.surveysFromGroups"
                                          ),
                                          order: -10
                                        }
                                      },
                                      [
                                        _c("GroupSurveyGroupSelector", {
                                          ref: "groupSurveyGroupSelector",
                                          attrs: { group: group },
                                          on: {
                                            change: function($event) {
                                              _vm.selectedSurveyGroups = $event
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3796332828
                      )
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c("div", { staticClass: "form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.generateBadges,
                      expression: "generateBadges"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox", id: _vm.uid + "generateBadge" },
                  domProps: {
                    checked: Array.isArray(_vm.generateBadges)
                      ? _vm._i(_vm.generateBadges, null) > -1
                      : _vm.generateBadges
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.generateBadges,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.generateBadges = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.generateBadges = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.generateBadges = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: _vm.uid + "generateBadge" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "visitorManagement.cockpit.directRegistration.modal.generateBadges"
                          )
                        ) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    type: "button",
                    disabled: !_vm.canSave || _vm.saving
                  },
                  on: {
                    click: function($event) {
                      return _vm.onSave(false)
                    }
                  }
                },
                [
                  !_vm.saving
                    ? _c("i", { staticClass: "fa fa-save" })
                    : _c("Spinner", { attrs: { small: true } }),
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("btnSave")) + "\n        "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  attrs: {
                    type: "button",
                    disabled: !_vm.canSave || _vm.saving
                  },
                  on: {
                    click: function($event) {
                      return _vm.onSave(true)
                    }
                  }
                },
                [
                  !_vm.saving
                    ? _c("i", { staticClass: "fa fa-play" })
                    : _c("Spinner", { attrs: { small: true } }),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "visitorManagement.cockpit.directRegistration.saveAndCheckIn"
                        )
                      ) +
                      "\n        "
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }